export const employerPOCMappingTo9141CSectionB = {
  name: "Employer POC Form Mapping for 9141C",
  machine_name: "employer_9141c_profile_mapping",
  targetFormDetailName: "Form ETA-9141C",
  targetSectionName: "Employer Point-of-Contact Information",
  targetSectionLabel: "B",
  fields: [
    {
      profileFieldName: "poc_emp_last_name",
      formTargetField: "requestorPocLastName",
    },
    {
      profileFieldName: "poc_emp_first_name",
      formTargetField: "requestorPocFirstName",
    },
    {
      profileFieldName: "poc_emp_middle_name",
      formTargetField: "requestorPocMiddleName",
    },
    {
      profileFieldName: "poc_emp_job_title",
      formTargetField: "requestorPocJobTitle",
    },
    {
      profileFieldName: "poc_emp_address1",
      formTargetField: "requestorPocAddr1",
    },
    {
      profileFieldName: "poc_emp_address2",
      formTargetField: "requestorPocAddr2",
    },
    {
      profileFieldName: "poc_emp_city",
      formTargetField: "requestorPocCity",
    },
    {
      profileFieldName: "poc_emp_country_id",
      formTargetField: "requestorPocCountry",
    },
    {
      profileFieldName: "poc_emp_state_id",
      formTargetField: "requestorPocState",
    },
    {
      profileFieldName: "poc_emp_zip",
      formTargetField: "requestorPocPostalCode",
    },
    {
      profileFieldName: "poc_emp_province",
      formTargetField: "requestorPocProvince",
    },
    {
      profileFieldName: "poc_emp_phone",
      formTargetField: "requestorPocPhone",
    },
    {
      profileFieldName: "poc_emp_phone_ext",
      formTargetField: "requestorPocPhoneExt",
    },
    {
      profileFieldName: "poc_emp_email",
      formTargetField: "requestorPocEmail",
    },
  ],
};

export const employerMappingTo9141CSectionC = {
  name: "Employer Profile Form Mapping for 9141C",
  machine_name: "employer_9141c_profile_mapping",
  targetFormDetailName: "Form ETA-9141C",
  targetSectionName: "Employer Information",
  targetSectionLabel: "C",
  fields: [
    {
      profileFieldName: "new_profile_emp_legal_name",
      formTargetField: "empBusinessName",
    },
    {
      profileFieldName: "new_profile_emp_dba",
      formTargetField: "empTradeName",
    },
    {
      profileFieldName: "new_profile_emp_address1",
      formTargetField: "empAddr1",
    },
    {
      profileFieldName: "new_profile_emp_address2",
      formTargetField: "empAddr2",
    },
    {
      profileFieldName: "new_profile_emp_city",
      formTargetField: "empCity",
    },
    {
      profileFieldName: "new_profile_emp_country_id",
      formTargetField: "empCountry",
    },
    {
      profileFieldName: "new_profile_emp_state_id",
      formTargetField: "empState",
    },
    {
      profileFieldName: "new_profile_emp_zip",
      formTargetField: "empPostcode",
    },
    {
      profileFieldName: "new_profile_emp_province",
      formTargetField: "empProvince",
    },
    {
      profileFieldName: "new_profile_emp_phone",
      formTargetField: "empPhone",
    },
    {
      profileFieldName: "new_profile_emp_phone_ext",
      formTargetField: "empPhoneext",
    },
    {
      profileFieldName: "new_profile_emp_fein",
      formTargetField: "empFein",
    },
    {
      profileFieldName: "new_profile_emp_naics_description",
      formTargetField: "empNaicsDesc",
    },
    {
      profileFieldName: "new_profile_emp_naics",
      formTargetField: "empNaics",
    },
  ],
};
